import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';

import { APIService } from './api.service';

@EnableClassTelemetry()
@Injectable()
export class AIAgentAPIService extends APIService {
  getBaseUrl(): string {
    const appConfig = (window as any).appConfig || {};
    if (appConfig.aiAssistant && appConfig.aiAssistant.flowiseUrl) {
      return appConfig.aiAssistant.flowiseUrl;
    }
    return 'http://localhost:3000';
  }

  getBaseHeaders() {
    return {
      Authorization: this.getToken(),
    };
  }

  getFlowId(): string | null {
    const appConfig = (window as any).appConfig || {};
    if (appConfig.aiAssistant && appConfig.aiAssistant.flowId) {
      return appConfig.aiAssistant.flowId;
    }
    return null;
  }

  public async chat(input: string, functions: any[], steps: string, context: string): Promise<any> {
    const data: any = {
      question: input,
      overrideConfig: {
        spotlightToolkitSchema: { functions },
        promptValues: { context, steps },
      },
    };
    const sessionId = this.localStorage.getItem('chat-session-id', 'session');
    if (sessionId) {
      data.overrideConfig.sessionId = sessionId;
    }
    const result: any = await this.post<any>(`/api/v1/prediction/${this.getFlowId()}`, data);
    if (result.sessionId) {
      this.localStorage.setItem('chat-session-id', result.sessionId, 'session');
    }
    let tools: any[] = [];
    if (result.usedTools) {
      tools = result.usedTools;
    } else if (result.agentReasoning) {
      tools = result.agentReasoning
        .map((a: any) => a.usedTools)
        .flat()
        .filter((t: any) => !!t);
    }
    return { text: result.text, tools };
  }
}
